import { GroupGet } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import { Group } from "./interfaces";

export const makeGroup = ({ connection, company }: ApiSliceParams) => {
    const {
        items: groups,
        allLoading: loading,
        listen,
    } = createListController<GroupGet, Group>({
        name: "group",
        connection,
        list: (con) => con.group.items({ company: company.value }),
    });

    const get = (id: string | undefined | null) => {
        if (!id) {
            return null;
        }

        return groups.value.find((e) => e.id === id) ?? null;
    };

    return { groups, loading, get, listen };
};
